import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {
  TableOffsetPaginationDataModel,
  TablePaginationTypesEnum,
} from '../../../../models/table/tablePaginationDataModel';
import {getSettingsPanel} from '../../../../store/panels/settings/settingsPanelSelectors';
import {isSettingsResourcesDevelopersResource} from '../../../../store/panels/settings/settingsPanelState';
import {DevelopersApplicationsTable} from './developersApplicationsTable';

/*
 * Selectors.
 */

const getDeveloperResources = createSelector([getSettingsPanel], (panel) => {
  if (!panel) {
    return undefined;
  }
  const {resources} = panel;
  if (!isSettingsResourcesDevelopersResource(resources)) {
    return undefined;
  }
  return resources;
});

const getLocalApplicationIds = createSelector([getDeveloperResources], (resources) => {
  if (!resources) {
    return [];
  }
  return resources.localApplicationIds ?? [];
});

const getPaginationData = createSelector([getDeveloperResources], (resources) => {
  if (!resources || !resources.localApplicationIds) {
    return undefined;
  }
  const initialPaginationData: TableOffsetPaginationDataModel = {
    type: TablePaginationTypesEnum.OFFSET,
    canLoadMore: Boolean(resources.canLoadMoreLocalApplications),
    offset: (resources.localApplicationIds ?? []).length,
  };
  return initialPaginationData;
});

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  localApplicationIds: getLocalApplicationIds,
  paginationData: getPaginationData,
}));

export const DevelopersApplicationsTableContainer = connect(mapStateToProps)(DevelopersApplicationsTable);
